import { createSlice } from '@reduxjs/toolkit';
const EMPTY_ARRAY = [] // stable reference;
const initialState = {
	data: {
		companyData: null,
		companyRoles: EMPTY_ARRAY,
	},
	loading: false,
	error: null,
};

const selectedCompanySlice = createSlice({
	name: 'selectedCompany',
	initialState,
	reducers: {
		setCompanyData: (state, action) => {
			state.data.companyData = action.payload;
			state.loading = false;
			state.error = null;
		},
		setCompanyRoles: (state, action) => {
			state.data.companyRoles = action.payload;
			state.loading = false;
			state.error = null;
		},
		setCompany: (state, action) => {
			// Option to set both at once if needed
			state.data.companyData = action.payload.companyData;
			state.data.companyRoles = action.payload.companyRoles;
			state.loading = false;
			state.error = null;
		},
		setLoading: (state, action) => {
			state.loading = action.payload;
		},
		setError: (state, action) => {
			state.error = action.payload;
			state.loading = false;
		},
		clearCompany: (state) => {
			state.data.companyData = null;
			state.data.companyRoles = null;
			state.loading = false;
			state.error = null;
		},
		clearCompanyData: (state) => {
			state.data.companyData = null;
		},
		clearCompanyRoles: (state) => {
			state.data.companyRoles = null;
		},
	},
});

export const { setCompanyData,setCompanyRoles,setCompany, setLoading, setError,clearCompany, clearCompanyData,clearCompanyRoles } = selectedCompanySlice.actions;
export default selectedCompanySlice.reducer;